<script lang="ts" setup>

	defineProps<{
		show?: boolean;
	}>();

	const emit = defineEmits(['show-substitutes']);

	const toggleSubstitutesModal = () => emit('show-substitutes');
</script>

<template>
	<button v-if="show"
	        class="open-substitutes"
	        type="button"
	        @click="toggleSubstitutesModal">

		<svg class="icon-modal-substitute" height="25" width="25">
			<use xlink:href="/assets/images/build/svg-sprite.min.svg#icon-substitute"></use>
		</svg>
	</button>
</template>
